function Button({onClickHandler, text}) {
  return (
    <button className="form-btn" type="button" onClick={() => onClickHandler()}>{text}</button>
  );
}

export default Button;